export default "__VITE_ASSET__BUGovRLY__"